import React from "react";
import axios from "axios";
import ErrorMessage from "../components/ui/ErrorMessage";

const defaultPageClass =
  "userMenuContent content-full flex flex-col content-full flex flex-col";

interface Props {
  className?: string;
  children: React.ReactNode;
  silent?: boolean;
}

const initialState = {
  error: null,
  errorInfo: null,
};

/**
 * This must be a Component class because it uses componentDidCatch
 */
export default class ErrorBoundary extends React.Component<Props> {
  public state = initialState;

  public componentDidCatch(err, info) {
    this.setState({
      error: err,
      errorInfo: info,
    });
    if (process.env.NODE_ENV === "production") {
      this.logErrorToMyService(err, info);
    }
  }

  public logErrorToMyService(error: Error, errorInfo) {
    axios.post("/ajax/view/log_agent_error", {
      url: window.location.href,
      error: error.message,
      errorInfo,
    });
  }

  public render() {
    if (this.state.errorInfo) {
      if (this.props.silent) {
        console.error(this.state.error);
        return null;
      }

      return (
        <div className={this.props.className ?? defaultPageClass}>
          <h2 style={{ color: "smokewhite" }}>
            <ErrorMessage>{this.state.error.message}</ErrorMessage>
          </h2>
          <details open={process.env.NODE_ENV !== "production"} className="mh4">
            <div
              style={{
                whiteSpace: "pre-wrap",
                padding: "0 2rem",
              }}
            >
              {this.state.errorInfo.componentStack}
            </div>
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}
